var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.breadcrumbs.impersonatedWarning && !_vm.error404 && !_vm.isAnonymousContext)?_c('div',{staticStyle:{"margin":"0","max-height":"30px"},attrs:{"id":"ccp-view-impersonated"}},[_vm._v(" "+_vm._s(_vm.breadcrumbs.impersonatedWarning)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }